import React, { useEffect, useState } from 'react';
import moment from 'moment';
import getBADevice from '@/utils/getBADevice';
import { manipulateBADevice, sendMessage } from './utils';
import client from '@/lib/feathers';
// components
import Swal from 'sweetalert2';
import { Button } from '@alifd/next';
// styles
import styles from './BAGroup.module.scss';
// types
import type { BaDevice } from '@/types/database/baDevice';
import type { User } from '@/types/database/users';
import type { ChargingPile } from '@/types/database/chargingPile/chargingPile';

type socketData = {
  name: string;
  text: string;
  group: string;
  type: string;
  value: string;
};

const powerStatus = {
  on: { color: 'green', text: '已通電' },
  off: { color: '#a5a5a5', text: '未通電' },
};

const BAGroup: React.FC<{
  pile: ChargingPile;
  pileStatus: string;
}> = ({ pile, pileStatus }) => {
  const [baDevice, setBaDevice] = useState<{
    status?: BaDevice;
    on?: BaDevice;
    off?: BaDevice;
  }>({});
  const [BAStatus, setBAStatus] = useState<'on' | 'off'>('off');

  const { chargingPileID: pileDeviceId } = pile;

  useEffect(() => {
    client.io.on('updatemultistate', (arr: socketData[]) => {
      const status = arr.find(
        (item) => item.text === `電表通電${pileDeviceId}`
      );
      if (status) {
        setBAStatus(status.value === '開啟' ? 'on' : 'off');
      }
    });
  }, [pileDeviceId]);

  const getHandleControlBADevice = (
    type: typeof BAStatus,
    item: socketData
  ) => {
    const handleControlBADevice = async () => {
      const isConfirm = await Swal.fire({
        title: `確定要${type === 'on' ? '開啟' : '關閉'}充電樁嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      });
      if (isConfirm.isConfirmed) {
        manipulateBADevice(item);
        // 發送通知
        // 通知管理員
        const adminUsers: User[] = (
          await client.service('users').find({
            query: {
              auth: {
                $in: ['admin', 'superAdmin'],
              },
            },
          })
        ).data;
        adminUsers.forEach((admin) =>
          sendMessage(
            { _id: admin._id, firebaseClass: '汽車充電樁' },
            `${pile.householdNumber}住戶車位：${
              pile.parkingNumber
            }，於${moment().format('YYYY-MM-DD HH:mm:ss')}遭到手動${
              type === 'on' ? '開啟' : '關閉'
            }`,
            '/ezpro/energy/monitor'
          )
        );
        // 通知住戶
        if (pile.householdNumber) {
          sendMessage(
            {
              householdNumbers: pile.householdNumber,
              firebaseClass: '汽車充電樁',
            },
            `您的車位：${pile.parkingNumber}充電樁已被手動${
              type === 'on' ? '開啟' : '關閉'
            }`,
            '/mobile/energy/energyFrontDesk'
          );
        }
      }
    };
    return handleControlBADevice;
  };

  useEffect(() => {
    (async () => {
      const res = await getBADevice(pileDeviceId);
      setBAStatus(
        res.find((item) => item.text === `電表通電${pileDeviceId}`)?.value ===
          '開啟'
          ? 'on'
          : 'off'
      );
      setBaDevice({
        status: res.find((item) => item.text === `電表通電${pileDeviceId}`),
        on: res.find((item) => item.text === `電表開${pileDeviceId}`),
        off: res.find((item) => item.text === `電表關${pileDeviceId}`),
      });
    })();
  }, [pileDeviceId]);

  return (
    <>
      <strong>電表狀態</strong>
      <Button
        style={{
          backgroundColor: powerStatus[BAStatus].color,
          color: '#FFFFFF',
        }}
        disabled
      >
        {powerStatus[BAStatus].text}
      </Button>
      <div className={styles.pileCardBtnContainer}>
        {baDevice.off && (
          <Button onClick={getHandleControlBADevice('off', baDevice.off)}>
            關閉
          </Button>
        )}
        {baDevice.on && (
          <Button
            onClick={getHandleControlBADevice('on', baDevice.on)}
            disabled={pileStatus === 'waiting'}
          >
            開啟
          </Button>
        )}
      </div>
    </>
  );
};

export default BAGroup;
